/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { DataContextProvider } from '@forge/data-connector';
import React from 'react';
import { ContextProvider, updateApiConfig } from '../../../context/ApiContext';
import { FileUploadProvider } from '../../../context/FileUploadContext/FileUploadContext';
import IEnergyManagementProps from '../../DashboardKPIWidgets/IEnergyManagementProps';
import DataUploadComponent from './DataUploadComponent';
import DataUploadCards from './DataUploadCards';
import { withLocalization } from '../../../locales/withLocalization';

const DataUploadSettingsWidget = (props: IEnergyManagementProps) => {
  const { connectorConfig, emaasContext } = props;

  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig,
        ...emaasContext
      })}
    >
      <FileUploadProvider>
        <DataContextProvider config={connectorConfig}>
          <DataUploadCards {...props} />
        </DataContextProvider>
      </FileUploadProvider>
    </ContextProvider>
  );
};

export default withLocalization<IEnergyManagementProps>(
  DataUploadSettingsWidget
);
